export default "__VITE_ASSET__2liH85HF__"